import { render } from "./BaseTaxonPage.vue?vue&type=template&id=7a137144"
import script from "./BaseTaxonPage.vue?vue&type=script&lang=js"
export * from "./BaseTaxonPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__